import { isString, omitBy } from 'lodash';

const REQUEST_SUFFIX = '_REQUEST';
const PROGRESS_SUFFIX = '_PROGRESS';
const SUCCESS_SUFFIX = '_SUCCESS';
const FAILURE_SUFFIX = '_FAILURE';
const ABORT_SUFFIX = '_ABORT';

export const requestType = type => `${type}${REQUEST_SUFFIX}`;
export const progressType = type => `${type}${PROGRESS_SUFFIX}`;
export const successType = type => `${type}${SUCCESS_SUFFIX}`;
export const failureType = type => `${type}${FAILURE_SUFFIX}`;
export const abortType = type => `${type}${ABORT_SUFFIX}`;

export const makeType = (type, cb) =>
  isString(type) ? cb(type) : { ...type, type: cb(type.type) };

export const request = type => makeType(type, requestType);
export const progress = type => makeType(type, progressType);
export const success = type => makeType(type, successType);
export const failure = type => makeType(type, failureType);
export const abort = type => makeType(type, abortType);

export const restTypes = type => [request(type), success(type), failure(type), abort(type)];

export const isRequestType = type => isString(type) && type.endsWith(REQUEST_SUFFIX);
export const isProgressType = type => isString(type) && type.endsWith(PROGRESS_SUFFIX);
export const isSuccessType = type => isString(type) && type.endsWith(SUCCESS_SUFFIX);
export const isFailureType = type => isString(type) && type.endsWith(FAILURE_SUFFIX);
export const isAbortType = type => isString(type) && type.endsWith(ABORT_SUFFIX);

export const restify = obj =>
  JSON.stringify(obj, (key, value) => (['', null].includes(value) ? undefined : value));

export const omitRestEmpty = obj => omitBy(obj, value => !value && value !== 0 && typeof value !== 'boolean');
